import { Address } from 'api/models/Common/Address'

type AddressDisplayProps = {
  address: Address
  line1Only?: boolean
}
const AddressDisplay = ({
  address,
  line1Only = false,
}: AddressDisplayProps) => {
  if (address && address !== undefined) {
    if (line1Only) {
      const firstLine = address.addressLine1 || address.formattedAddress || ''
      const area = address.postCode || address.town || ''
      return (
        <span>
          {firstLine} {area}
        </span>
      )
    }
    if (address.formattedAddress !== undefined) {
      return <span>{address.formattedAddress}</span>
    } else if (address.addressLine1.indexOf(',') > 1) {
      Object.values(address).splice(1)
      return <span>{address.addressLine1}</span>
    } else {
      return (
        <span>
          {address.addressLine1 ? `${address.addressLine1}, ` : null}
          {address.addressLine2 ? `${address.addressLine2}, ` : null}
          {address.town ? `${address.town}, ` : null}
          {address.county ? `${address.county}, ` : null}
          {address.country ? `${address.country}` : null}
        </span>
      )
    }
  }
  return ''
}

export const AddressDetailDisplay = ({ address }: AddressDisplayProps) => {
  if (address && address !== undefined) {
    if (address.addressLine1.indexOf(',') > 1) {
      Object.values(address).splice(1)
      return <span>{address.addressLine1}</span>
    } else {
      return (
        <span>
          {address.addressLine1 ? `${address.addressLine1}, ` : null}
          {address.addressLine2 ? `${address.addressLine2}, ` : null}
          {address.town ? `${address.town}, ` : null}
          {address.county ? `${address.county}, ` : null}
          {address.country ? `${address.country}` : null}
        </span>
      )
    }
  }
  return ''
}

export default AddressDisplay
